export const AccountTypeStringEnum = {
  Lending: 'Lending',
  Mortgage: 'Mortgage',
  Savings: 'Savings',
  Chequing: 'Chequing',
  LineOfCredit: 'Line of Credit',
  TermDeposit: 'Term Deposit',
  Registered:'Registered',
  Loan:'Loan',
  TFSA:'TFSA',
  RRIF:'RRIF',
  RRSP:'RRSP',
  Term:'Term',
  Share:'Share',
};

export const AccountTypeEnum = {
  Lending: 'Lending',
  Mortgage: 'Mortgage',
  Savings: 'Savings',
  Chequing: 'Chequing',
  LineOfCredit: 'LineOfCredit',
  Loan:'Loan',
  TermDeposit: 'TermDeposit',
  Registered:'Registered',
  TFSA:'TFSA',
  RRIF:'RRIF',
  RRSP:'RRSP',
  Term:'Term',
  Share:'Share',
};
